import { PrivateRoute } from '@/components/PrivateRoute'
import { RouteLayout } from '@/components/RouteLayouts'
import { LoginPage, Page404, Route as RouteType, type RouteKey } from '@/pages'
import AuthPage from '@/pages/AuthPage'
import BanPage from '@/pages/BanPage'
import GoogleAuthPage from '@/pages/GoogleAuthPage'
import MissionDetailPage from '@/pages/MissionDetailPage'
import MissionsPage from '@/pages/MissionsPage'
import NectarTaskPage from '@/pages/NectarTaskPage'
import ProfilePage from '@/pages/ProfilePage'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { MissionsHeaderLayout } from './MissionsHeaderLayout'

/* const MISSIONS_WEBVIEW_KEYS = [
  'missionsWebview',
  'missionWebview',
  'nectarTasksWebview',
  'profileWebview'
] satisfies RouteKey[] */

const MISSIONS_PRIVATE_KEYS = ['missions', 'mission', 'nectarTasks', 'profile'] satisfies RouteKey[]
const MISSIONS_PUBLIC_KEYS = ['login', 'auth', 'googleAuth', 'ban'] satisfies RouteKey[]

export const missionRoutes: Record<string, RouteType> = {
  login: { path: '/login', Component: LoginPage, isPublic: true },
  auth: { path: '/auth', Component: AuthPage, isPublic: true },
  googleAuth: { path: '/auth/google', Component: GoogleAuthPage, isPublic: true },
  ban: { path: '/banned', Component: BanPage, isPublic: true },
  missions: { path: '/', Component: MissionsPage, isPublic: true },

  mission: { path: '/missions/:id', Component: MissionDetailPage },
  nectarTasks: { path: '/missions/nectar/:projectId/tasks', Component: NectarTaskPage },
  profile: { path: '/profile', Component: ProfilePage }
}

//const webviewRoutes = MISSIONS_WEBVIEW_KEYS.map((key) => routes[key])
const privateRoutes = MISSIONS_PRIVATE_KEYS.map((key) => missionRoutes[key])
const publicRoutes = MISSIONS_PUBLIC_KEYS.map((key) => missionRoutes[key])

export const MissionsLayout = () => (
  <>
    <Routes>
      {/*  <Route
        element={
          <PrivateRoute>
            <RouteLayoutWebview />
          </PrivateRoute>
        }
      >
        {webviewRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Component />
              </Suspense>
            }
          />
        ))}
      </Route> */}
      <Route
        element={
          <PrivateRoute>
            <MissionsHeaderLayout />
          </PrivateRoute>
        }
      >
        {privateRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Component />
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<RouteLayout />}>
        {publicRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Component />
              </Suspense>
            }
          />
        ))}
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  </>
)
